import React from 'react'
import { IScaleInterval } from './calendarTypes'

interface IScaleColumnProps {
  scaleUnit: number
  scaleFormat: string
  scaleIntervals: IScaleInterval[]
  cellHeight: number
  cellWidth: number
}

const ScaleColumn: React.FC<IScaleColumnProps> = ({
  scaleFormat,
  scaleIntervals,
  cellHeight,
  cellWidth,
}) => (
  <div>
    {scaleIntervals.map((scaleInterval, index) => (
      <div
        key={index}
        className="weekCalendar__scaleCell"
        style={{
          height: cellHeight,
          width: cellWidth,
          borderTop: index === 0 ? '1px solid #b7b7b7' : '',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            backgroundColor: '#FFF',
            padding: '5px',
            top: `calc(-${cellHeight / 2}px + ${cellHeight * index}px)`,
            position: 'absolute',
            userSelect: 'none',
          }}
        >
          {scaleInterval.start.format(scaleFormat)}
        </span>
      </div>
    ))}
  </div>
)

export default ScaleColumn
